/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/funds_in'
export default icon
